window.Products.Clothing.FlowPulloverHoodie = function() {
};
window.Products.Clothing.FlowPulloverHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.FlowPulloverHoodie.dpi = 150;
window.Products.Clothing.FlowPulloverHoodie.has_3d = true;
window.Products.Clothing.FlowPulloverHoodie.id = 115;
window.Products.Clothing.FlowPulloverHoodie.slug = 'flow-pullover-hoodie';
window.Products.Clothing.FlowPulloverHoodie.syncColors = true;
window.Products.Clothing.FlowPulloverHoodie.texturesLoaded = 0;
window.Products.Clothing.FlowPulloverHoodie.texturesLoading = false;
window.Products.Clothing.FlowPulloverHoodie.use_glb = true;

window.Products.Clothing.FlowPulloverHoodie.prototype.outsideObject = 0;
window.Products.Clothing.FlowPulloverHoodie.prototype.detailsObject = 1;
window.Products.Clothing.FlowPulloverHoodie.prototype.position = 0.1;

window.Products.Clothing.FlowPulloverHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}

	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.FlowPulloverHoodie.prototype.getColor = function(_name){
	colors = {
		"blush": 0xd8b8a3,
		"black": 0x171616,
		"bone": 0xdfd8c6,
		"dusty_rose": 0xd1827b,
		"misty_blue": 0x91afba,
		"sage": 0x93937f,
		"shadow": 0x4d494a,
	};

	return new THREE.Color(colors[_name]);
};